var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content impact-content"},[_vm._m(0),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('textarea',{staticClass:"form-control",attrs:{"name":"widget","cols":"50","rows":"7"},domProps:{"value":_vm.jsTemplate}})])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('h1',{staticClass:"h1"},[_vm._v("Donation Button Widget")])])
}]

export { render, staticRenderFns }